<template>
<div class="jfdetail">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('moneylog.title')}}
			</div>
		</div>
	</div>
	<van-pull-refresh v-model="isLoading" class="fixedStyle"  @refresh="onRefresh">
	  <van-list
	      v-model="loading"
	      :finished="finished"
	      :immediate-check="false"
	      :finished-text="$t('common.nomore')"
	      @load="onLoad">
		  <div class="list-container">
			  <van-cell-group class="custom-cell-group">
			    <van-cell v-for="(item,i) in tableList" :key="i" class="custom-cell">
					<template #title>
						<div class="box">
							<div class="left">
								$
							</div>
							<div class="content">
								<p class="type-text">
									{{item.title || typeExt[item.type]}}
								</p>
								<span class="time-text">
									{{item.createtime || $t('moneylog.summary')}}
								</span>
							</div>
						</div>
					</template>
					<template #default>
						<span class="amount-positive" v-if="item.money>=0">
							+{{formatMoney(item.money)}}
						</span>
						<span class="amount-negative" v-else>
							-{{formatMoney(Math.abs(item.money))}}
						</span>
					</template>
				</van-cell>
			  </van-cell-group>
		  </div>
	  </van-list>
	  <van-empty :description="$t('common.nodata')" v-if="tableList.length === 0"/>
	</van-pull-refresh>
</div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data () {
    return {
      page:1,
      isLoading: false,
      count:0,
	  limit:10,
      loading: false,
      finished: false,
      refreshing: false,
      tableList:[],
	  typeExt:['0',this.$t('moneylog.type1'),this.$t('moneylog.type2'),this.$t('moneylog.type3'),this.$t('moneylog.type4'),this.$t('moneylog.type5'),this.$t('moneylog.type6')],
    }
  },
  mounted () {
    this.getPinglunList()
    window.addEventListener("scroll", this.scrollTops, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollTops);
  },
  methods: {
	formatMoney(value) {
	  const amount = Number(value || 0);
	  return Number.isFinite(amount) ? amount.toFixed(2) : '0.00';
	},
	isWithdrawalLog(item) {
	  return [5, 6].includes(Number(item.type)) || /withdraw|提现|取款/i.test(String(item.title || ''));
	},
	withdrawalLogKey(item) {
	  const businessId = item.withdraw_id || item.order_id || item.order_no || item.withdraw_no || item.sn;
	  if (businessId) return `withdraw:${businessId}`;
	  const time = item.createtime || item.create_time || item.created_at || '';
	  const amount = Math.abs(Number(item.money || 0)).toFixed(2);
	  return `withdraw:${time}:${amount}`;
	},
	mergeMoneyLogs(currentRows, incomingRows) {
	  const result = [];
	  const withdrawalIndexes = new Map();
	  [...currentRows, ...incomingRows].forEach(item => {
	    if (!this.isWithdrawalLog(item)) {
	      result.push(item);
	      return;
	    }
	    const key = this.withdrawalLogKey(item);
	    if (!withdrawalIndexes.has(key)) {
	      withdrawalIndexes.set(key, result.length);
	      result.push(item);
	      return;
	    }
	    // 接口按最新记录在前返回；保留第一条的最终状态，同时补齐旧记录字段。
	    const index = withdrawalIndexes.get(key);
	    result[index] = { ...item, ...result[index] };
	  });
	  return result;
	},
	  back(){
	    return window.history.back();
	  },
	quickList(id){
	  if(!localStorage.getItem('token')){
	    this.$router.push({path:'/Login'})
	  }else {
	    this.$router.push({path:'/PinglunDetail?id='+id})
	  }
	
	},
    longPress() {
      document.querySelector('.fixedStyle').scrollTop = 0
    },
    scrollTops(){
      const container = document.querySelector('.fixedStyle');
      this.scrollTop1 = container ? container.scrollTop : 0;
    },

    getPinglunList(){
        this.$http({
          method: 'get',
          data:{page: this.page,limit: this.limit},
          url: 'money_log'
        }).then(res=>{
          if (!res || !res.ok || !res.data) {
            this.finished = true;
            this.loading = false;
            return;
          }
          const payload = res.data;
          const rows = Array.isArray(payload.data) ? payload.data : [];
		  this.tableList = this.mergeMoneyLogs(this.tableList, rows);
          this.count = Number(payload.total || rows.length);
          this.page++;
          this.finished = rows.length < this.limit || this.tableList.length >= this.count;
          this.loading = false;
        }).catch(() => {
          this.finished = true;
          this.loading = false;
        })
    },
    onRefresh(){
      this.page = 1;
      this.tableList = [];
      this.finished = false;
      this.loading = true;
      this.getPinglunList();
      this.isLoading = false;
      Toast(this.$t('common.refresh'));
    },
    onLoad() {
      //初始化列表
      this.getPinglunList()
	  let timer = setTimeout(() => {
	    if (this.refreshing) {
	      this.tableList = [];
	      this.refreshing = false;
	    }
	    this.loading = false;
	    if (this.tableList.length === this.count) {
	      this.finished = true;
	    }
	    this.finished && clearTimeout(timer);//清除计时器
	  }, 500);
    },
  },
}
</script>

<style scoped>
:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.jfdetail {
    width: 100%;
    min-height: 100vh;
    background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left {
    padding: 0 15px;
}

.van-nav-bar__arrow {
    color: white !important;
    font-size: 1.2rem;
    font-weight: bold;
}

/* 内容区域样式 */
.fixedStyle {
    background: white;
    min-height: calc(100vh - 3.5rem);
}

.list-container {
    padding: 1rem;
}

/* 自定义单元格组 */
.custom-cell-group {
    background: transparent;
    border: none;
}

.custom-cell-group::after,
.custom-cell-group::before {
    display: none;
}

/* 每个栏目带边框 */
.custom-cell {
    margin-bottom: 0.8rem;
    border: 1.5px solid #e8e8e8;
    border-radius: 12px;
    padding: 1rem;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
}

.custom-cell:active {
    background-color: #f8f9ff;
    border-color: #667eea;
    transform: translateY(1px);
}

.custom-cell::after {
    display: none;
}

/* 内容布局 */
.box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.5rem;
}

.left {
    width: 2.8rem;
    height: 2.8rem;
    background: linear-gradient(135deg, #3498db, #8e44ad);
    margin-right: 12px;
    border-radius: 50%;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    font-weight: 600;
    flex-shrink: 0;
}

.content {
    flex: 1;
}

.type-text {
    font-weight: 600;
    color: #333;
    font-size: 1rem;
    margin-bottom: 0.3rem;
}

.time-text {
    font-size: 0.75rem;
    color: #888;
}

.memo-text {
    color: #969799 !important;
    font-size: 0.8rem;
    line-height: 1.2;
}

/* 金额样式 */
.amount-positive {
    color: #3cd197 !important;
    font-size: 1.1rem;
    font-weight: 600;
}

.amount-negative {
    color: #f56969 !important;
    font-size: 1.1rem;
    font-weight: 600;
}

/* 列表加载状态样式 */
.van-list__error-text, 
.van-list__finished-text, 
.van-list__loading {
    color: #969799;
    font-size: 0.9rem;
    line-height: 1.5rem;
    text-align: center;
    padding: 1rem 0;
}

/* 空状态样式 */
.van-empty {
    padding: 3rem 1rem;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .list-container {
        padding: 0.8rem;
    }
    
    .custom-cell {
        padding: 0.8rem;
        margin-bottom: 0.6rem;
    }
    
    .left {
        width: 2.5rem;
        height: 2.5rem;
        font-size: 1.1rem;
    }
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.custom-cell {
    animation: fadeInUp 0.4s ease forwards;
}

.custom-cell:nth-child(odd) {
    animation-delay: 0.1s;
}

.custom-cell:nth-child(even) {
    animation-delay: 0.2s;
}

/* 资金明细：黑金轻奢主题 */
.jfdetail {
    color: #f2e7d3;
    background:
      linear-gradient(rgba(3,5,8,.86),rgba(3,5,8,.97)),
      url('../../assets/img/luxury-dating-bg-v2.png') center top/cover fixed no-repeat;
}

.custom-nav-bar {
    height: 4rem;
    line-height: 4rem;
    border-bottom: 1px solid rgba(220,181,101,.42);
    background: rgba(4,6,9,.96);
    box-shadow: 0 10px 28px rgba(0,0,0,.38);
}

.van-nav-bar__title,
.van-nav-bar__arrow {
    color: #edcd83 !important;
}

.van-nav-bar__title {
    font-size: 1.12rem;
    font-weight: 750;
    letter-spacing: .08em;
}

.fixedStyle {
    min-height: calc(100vh - 4rem);
    background: transparent;
}

.list-container {
    padding: 1rem .8rem 2rem;
}

.custom-cell-group {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
    gap: .8rem;
}

.custom-cell {
    min-height: 9.2rem;
    margin: 0;
    padding: 1rem;
    overflow: hidden;
    border: 1px solid rgba(220,181,101,.36);
    border-radius: 20px;
    background:
      radial-gradient(circle at 90% 5%,rgba(221,178,91,.13),transparent 42%),
      linear-gradient(145deg,rgba(18,20,24,.97),rgba(5,8,12,.98));
    box-shadow: 0 14px 32px rgba(0,0,0,.38),inset 0 1px 0 rgba(255,255,255,.035);
}

.custom-cell:active {
    border-color: rgba(239,207,137,.7);
    background: linear-gradient(145deg,rgba(27,23,16,.98),rgba(6,9,13,.98));
}

.custom-cell ::v-deep .van-cell__title {
    min-width: 0;
    width: 100%;
    flex: none;
}

.custom-cell ::v-deep .van-cell__value {
    position: static;
    display: flex;
    width: 100%;
    min-height: 1.5rem;
    margin-top: .65rem;
    justify-content: flex-end;
    align-items: center;
    flex: none;
}

.custom-cell ::v-deep .van-cell__value--alone {
    text-align: right;
}

.custom-cell {
    display: flex;
    flex-direction: column;
}

.box {
    margin: 0;
    align-items: center;
}

.left {
    width: 3rem;
    height: 3rem;
    margin-right: .75rem;
    color: #161006;
    font-size: 1.2rem;
    border: 1px solid rgba(250,224,165,.62);
    background: linear-gradient(135deg,#9e6e2d,#efd083,#b67e35);
    box-shadow: 0 7px 18px rgba(190,132,48,.26);
}

.type-text {
    margin: 0 0 .25rem;
    color: #e9cc8b;
    font-size: .98rem;
    font-weight: 720;
}

.time-text {
    color: #9e9484;
    font-size: .72rem;
}

.memo-text {
    display: block;
    margin-top: .55rem;
    padding-right: 0;
    line-height: 1.38;
    overflow-wrap: anywhere;
    word-break: break-word;
    white-space: normal;
}

.amount-positive,
.amount-negative {
    font-size: 1.12rem;
    font-weight: 780;
    letter-spacing: .01em;
}

.amount-positive { color: #e7c475 !important; }
.amount-negative { color: #e68a7f !important; }

.van-list__finished-text {
    padding: 1.4rem 0;
    color: #8d8272;
}

@media (max-width: 390px) {
    .custom-cell-group { grid-template-columns: 1fr; }
    .custom-cell { min-height: 7.8rem; }
}

@media (max-width: 430px) {
  .jfdetail {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    background-attachment: scroll;
  }

  .custom-nav-bar {
    height: auto;
    min-height: 58px;
    padding-top: env(safe-area-inset-top);
  }

  .custom-nav-bar .van-nav-bar__content {
    min-height: 58px;
  }

  .van-nav-bar__title {
    max-width: calc(100% - 96px);
    font-size: 17px;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .fixedStyle {
    min-height: calc(100svh - 58px);
  }

  .list-container {
    min-width: 0;
    padding: 12px 10px max(22px, env(safe-area-inset-bottom));
  }

  .custom-cell-group {
    min-width: 0;
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .custom-cell {
    width: 100%;
    min-width: 0;
    min-height: 118px;
    padding: 14px 12px;
    border-radius: 17px;
  }

  .box,
  .content {
    min-width: 0;
  }

  .left {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
  }

  .type-text,
  .time-text,
  .memo-text,
  .amount-positive,
  .amount-negative {
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .custom-cell ::v-deep .van-cell__value {
    min-width: 0;
  }

  .amount-positive,
  .amount-negative {
    display: block;
    text-align: right;
    white-space: normal;
  }
}
</style>
